// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fit_markers_button {
    background-color: white;
    border: none;
}

.marker-label {
    background-color: white;
    min-width: 160px;
    margin-left: 220px;
    margin-bottom: 20px;
    border-radius: 10px;
    overflow: hidden;
    word-wrap: break-word;
}

.custom-tools {
    background-color: white;
    border: none;
    border-radius: 10px;
    padding: 10px;
    margin-bottom: 20px;
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
    height: 100%;
    margin-left: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
    align-content: center;
}

.buttom-custom-tools {
    background-color: white;
    font-weight: bold;
    border: none;
    border-radius: 4px;
    cursor: pointer;
}

.custom-tools-container {
    position: absolute;
    bottom: 40px;
    height: 40px;
    left: 85%;
    transform: translateX(-50%);
    flex-direction: row;
    display: flex;
}`, "",{"version":3,"sources":["webpack://./src/pages/Map/map.css"],"names":[],"mappings":"AAAA;IACI,uBAAuB;IACvB,YAAY;AAChB;;AAEA;IACI,uBAAuB;IACvB,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,mBAAmB;IACnB,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;IACI,uBAAuB;IACvB,YAAY;IACZ,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,yCAAyC;IACzC,YAAY;IACZ,iBAAiB;IACjB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,uBAAuB;IACvB,iBAAiB;IACjB,YAAY;IACZ,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,SAAS;IACT,2BAA2B;IAC3B,mBAAmB;IACnB,aAAa;AACjB","sourcesContent":[".fit_markers_button {\n    background-color: white;\n    border: none;\n}\n\n.marker-label {\n    background-color: white;\n    min-width: 160px;\n    margin-left: 220px;\n    margin-bottom: 20px;\n    border-radius: 10px;\n    overflow: hidden;\n    word-wrap: break-word;\n}\n\n.custom-tools {\n    background-color: white;\n    border: none;\n    border-radius: 10px;\n    padding: 10px;\n    margin-bottom: 20px;\n    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);\n    height: 100%;\n    margin-left: 10px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    align-content: center;\n}\n\n.buttom-custom-tools {\n    background-color: white;\n    font-weight: bold;\n    border: none;\n    border-radius: 4px;\n    cursor: pointer;\n}\n\n.custom-tools-container {\n    position: absolute;\n    bottom: 40px;\n    height: 40px;\n    left: 85%;\n    transform: translateX(-50%);\n    flex-direction: row;\n    display: flex;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
